import React from 'react';
import { Facebook, Instagram, Youtube, Music, Mail } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-mabelita-dark text-white py-6 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">

        {/* Brand & Copyright */}
        <div className="text-center md:text-left">
          <h3 className="font-serif font-bold text-lg text-mabelita-light">Mabelita de la Cruz</h3>
          <p className="text-gray-400 text-xs mt-1">© {new Date().getFullYear()} Todos los derechos reservados.</p>
        </div>

        {/* Links */}
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-gray-300">
          <a href="#singer" className="hover:text-mabelita-accent transition-colors">La Artista</a>
          <a href="#singer#gallery" className="hover:text-mabelita-accent transition-colors">Actuaciones</a>
          <a href="#singer#contact" className="hover:text-white text-mabelita-accent transition-colors font-bold uppercase tracking-wider text-xs flex items-center gap-1">Contratar</a>
          <a href="#tienda" className="hover:text-mabelita-accent transition-colors">Shopping</a>
        </div>

        {/* Contact & Social Icons */}
        <div className="flex items-center gap-4">
          <a href="#singer#contact" title="Formulario de Contratación" className="text-gray-400 hover:text-white transition-colors">
            <Mail size={20} />
          </a>
          <div className="w-px h-5 bg-white/20 mx-1"></div>
          <a href="https://www.facebook.com/profile.php?id=100074257451390" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-blue-500 transition-colors">
            <Facebook size={20} />
          </a>
          <a href="https://www.instagram.com/mabelitadcu13/" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-pink-500 transition-colors">
            <Instagram size={20} />
          </a>
          <a href="https://www.youtube.com/channel/UC6ubJkSocmftNZPdRneCPiA" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-red-500 transition-colors">
            <Youtube size={20} />
          </a>
          <a href="https://www.tiktok.com/@mabelita_dc" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-white transition-colors group" title="TikTok">
            <svg
              viewBox="0 0 24 24"
              width="20"
              height="20"
              className="fill-current group-hover:scale-110 transition-transform"
            >
              <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.12-3.44-3.17-3.61-5.46-.21-2.51 1.18-4.99 3.44-6.08 1.92-.95 4.27-.92 6.13.12v4.06c-1.22-.39-2.61-.31-3.76.31-1.1.58-1.84 1.66-1.92 2.91-.12 1.62.9 3.2 2.45 3.69 1.48.46 3.16.1 4.23-1.01.9-.92 1.34-2.26 1.34-3.56.02-5.59-.01-11.18.01-16.77z" />
            </svg>
          </a>
        </div>

      </div>
    </footer>
  );
};
